(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-custom"] && !Shopify.designMode) return;
  try {
    
class ProductGallery {
constructor(container) {
this.container = container;
this.mainImage = this.container.querySelector('#MainProductImage-{{ section.id }}');
this.thumbnails = this.container.querySelectorAll('.product-gallery__thumbnail a');
this.init();
}

init() {
if (!this.thumbnails.length) return;

this.thumbnails.forEach(thumb => {
thumb.addEventListener('click', this.onThumbClick.bind(this));
});

this.setActiveThumb(this.thumbnails[0]);
}

onThumbClick(event) {
event.preventDefault();
const target = event.currentTarget;
this.mainImage.src = target.href;
this.setActiveThumb(target);
}

setActiveThumb(target) {
this.thumbnails.forEach(thumb => {
thumb.removeAttribute('aria-current');
});
target.setAttribute('aria-current', 'true');
}
}

document.addEventListener('DOMContentLoaded', () => {
const galleryContainer = document.querySelector('.product-grid__gallery');
if (galleryContainer) {
new ProductGallery(galleryContainer);
}
});

  } catch(e) { console.error(e); }
})();
})();
